/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  QUARTER_REQUIRED,
  QUARTER_FORMAT_ERROR,
} from '../../../../../../SharedModules/AppConstants';
import {
  END_QTR_ERROR,
  VALIDATE_QUARTER_VALUE,
  END_QUATER_REQ,
  FAILED_MESSAGE_STUB_INVOICE,
  SUCCESS_MESSAGE_STUB_INVOICE,
  MANUFACTURER_ID_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  START_QUATER_REQ,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import { RadioGroupComponent } from '../../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { formatQuater } from '../../../../../Display/Claim/store/action';
import { NDCDetailsTextFieldComponent } from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { PLAN_TYPE_DATA, createForRadioData } from '../utils/constant';
import {
  createStubInvoiceAPI,
  setStubInvoiceFilterValue,
} from '../store/action';
import { autoFormateDate,validateDateQuarter } from '../../../../../../SharedModules/utilities/utilities';

export const checkQuaterIsValid = (quater) => {
  if (typeof quater === 'string' && quater?.includes('Q')) {
    const splitYear = quater.split('Q');
    const checkQuater = splitYear[0] <= 4;
    if (
      checkQuater &&
      splitYear.length === 2 &&
      splitYear[0].length === 1 &&
      (splitYear[1].length === 2 || splitYear[1].length === 4)
    ) {
      return true;
    }
    return false;
  }
  return false;
};

export const checkValidStartAndEndQtr = (startQtr, endQtr) => {
  if (startQtr && endQtr) {
    const splitStartQtr = startQtr.split('Q');
    const splitEndQtr = endQtr.split('Q');

    if (
      splitStartQtr[1] <= splitEndQtr[1] &&
      splitStartQtr[0] <= splitEndQtr[0]
    ) {
      return true;
    }
    return false;
  }
  return false;
};

const CreateStubInvoiceHeader = ({
  searchFilter,
  rebateData,
  setErrorMessages,
  setSuccessMessages,
}) => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [errors, setErrors] = useState({});
  const [rbtErr, setRbtErr] = React.useState(false);
  const validFilter = (filterValue) => {
    const localErrorMessage = [];
    const localErrors = {};

    if (!filterValue || !filterValue.rpc) {
      localErrorMessage.push(REBATE_PROGRAM_REQUIRED);
      localErrors.rpc = true;
      setRbtErr(true);
    }

    if (filterValue && filterValue.createFor === createForRadioData[0].value) {
      if (!filterValue || !filterValue.startQtr) {
        localErrorMessage.push(START_QUATER_REQ);
        localErrors.startQtrReq = true;
      } else if (
        filterValue &&
        filterValue.startQtr &&
        !checkQuaterIsValid(filterValue.startQtr)
      ) {
        if (!localErrorMessage.includes(QUARTER_FORMAT_ERROR)) {
          localErrorMessage.push(QUARTER_FORMAT_ERROR);
        }
        localErrors.startQtr = true;
      }

      if (!filterValue || !filterValue.endQtr) {
        localErrorMessage.push(END_QUATER_REQ);
        localErrors.endQtrReq = true;
      } else if (
        filterValue &&
        filterValue.endQtr &&
        !checkQuaterIsValid(filterValue.endQtr)
      ) {
        if (!localErrorMessage.includes(QUARTER_FORMAT_ERROR)) {
          localErrorMessage.push(QUARTER_FORMAT_ERROR);
        }
        localErrors.endQtr = true;
      }

      if (
        filterValue &&
        filterValue.startQtr &&
        filterValue.endQtr &&
        checkQuaterIsValid(filterValue.startQtr) &&
        checkQuaterIsValid(filterValue.endQtr) &&
        !checkValidStartAndEndQtr(filterValue.startQtr, filterValue.endQtr)
      ) {
        localErrorMessage.push(END_QTR_ERROR);
        localErrors.endQtrReq1 = true;
      }
    } else {
      if (!filterValue || !filterValue.mfg_id) {
        localErrorMessage.push(MANUFACTURER_ID_REQUIRED);
        localErrors.mfg_id = true;
      }

      if (!filterValue || !filterValue.qtr) {
        localErrorMessage.push(QUARTER_REQUIRED);
        localErrors.qtr = true;
      } else if (
        filterValue &&
        filterValue.qtr &&
        !checkQuaterIsValid(filterValue.qtr)
      ) {
        localErrorMessage.push(QUARTER_FORMAT_ERROR);
        localErrors.qtr = true;
      }
    }

    if (localErrorMessage.length > 0) {
      setErrorMessages(localErrorMessage);
      setErrors(localErrors);
      return false;
    }
    setErrorMessages([]);
    setErrors({});
    return true;
  };
  const handleBlur = (fieldName) => {
    setSuccessMessages([]);

    const fieldValue = searchFilter[fieldName];
    if (!fieldValue) return;

    let isValid = false;
    if (fieldName === 'startQtr' || fieldName === 'endQtr') {
      // Validate quarters
      isValid = checkQuaterIsValid(fieldValue);
    } else if (fieldName === 'qtr') {
      // Validate quarter for other case
      isValid = checkQuaterIsValid(fieldValue);
    } else if (fieldName === 'mfg_id') {
      // Manufacturer ID validation
      isValid = /^[0-9]+$/.test(fieldValue);
    }

    if (!isValid) {
      setErrors({
        ...errors,
        [fieldName]: true,
      });
    } else {
      setErrors({
        ...errors,
        [fieldName]: false,
      });
    }

    validFilter(searchFilter);
  };
 

  return (
    <>
      <div className="row">
        <div className="col-7">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Plan Type</legend>
            <div className="p-0 mt-2 row">
              <div className="mui-custom-form col-12 m-0">
                <RadioGroupComponent
                  data={PLAN_TYPE_DATA}
                  value={searchFilter && searchFilter.planType}
                  onChange={(_, value) => {
                    dispatch(setStubInvoiceFilterValue('planType', value));
                    dispatch(setStubInvoiceFilterValue('rpc', null));
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-5 mt-2">
          <fieldset className="custom-fieldset">
            <NDCDetailsTextFieldComponent
              label="Rebate Program"
              required
              value={searchFilter && searchFilter.rpc}
              className="ml-0 with-select"
              select
              selectReset
              selectData={rebateData}
              disabled={false}
              error={rbtErr}
              helperText={rbtErr ? REBATE_PROGRAM_REQUIRED : ''}
              onChange={(e) => {
                const value = e.target.value;

                if (value === '') {
                  dispatch(setStubInvoiceFilterValue('rpc', ''));
                  setRbtErr(true); // show error if empty
                } else {
                  const filterArr = rebateData.filter((item) => item.value === value);
                  if (filterArr.length > 0) {
                    dispatch(setStubInvoiceFilterValue('rpc', filterArr[0].value));
                    setRbtErr(false); // valid selection
                  } else {
                    setRbtErr(true); // invalid selection (not found in list)
                  }
                }
              }}
            />
          </fieldset>
        </div>
        <div className="col-12">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Create For</legend>
            <div className="p-0 row">
              <div className="mui-custom-form m-0 mt-4 col-12 d-flex">
                <RadioGroupComponent
                  data={createForRadioData}
                  value={searchFilter && searchFilter.createFor}
                  onChange={(_, value) => {
                    dispatch(setStubInvoiceFilterValue('createFor', value));
                    dispatch(setStubInvoiceFilterValue('startQtr', null));
                    dispatch(setStubInvoiceFilterValue('endQtr', null));
                    dispatch(setStubInvoiceFilterValue('qtr', null));
                    dispatch(setStubInvoiceFilterValue('mfg_id', null));
                    setSuccessMessages([]);
                    setErrorMessages([]);
                    setErrors({});
                  }}
                />
              </div>
              {searchFilter.createFor === createForRadioData[0].value && (
                <div className="m-0 col-6 d-flex">
                  <NDCDetailsTextFieldComponent
                    label="Start Quarter"
                    required
                    value={(searchFilter && searchFilter.startQtr) || ''}
                    error={
                      (errors && errors.startQtrReq
                        ? START_QUATER_REQ
                        : errors && errors.startQtr
                        ? QUARTER_FORMAT_ERROR
                        : null) || false
                    }
                    helperText={
                      (errors && errors.startQtrReq
                        ? START_QUATER_REQ
                        : errors && errors.startQtr
                        ? QUARTER_FORMAT_ERROR
                        : null) || false
                    }
                    className="ml-0 with-select"
                    disabled={false}
                    maxLength={6}
                    onChange={(e) => {
                      setSuccessMessages([]);
                      if (e.target.value === '') {
                        dispatch(setStubInvoiceFilterValue('startQtr', null));
                      } else if (
                        /^[0-9/Q]+$/g.test(e.target.value.toUpperCase())
                      ) {
                        dispatch(
                          setStubInvoiceFilterValue(
                            'startQtr',
                            e.target.value.toUpperCase()
                          )
                        );
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur('startQtr');
                      const rawValue = searchFilter?.startQtr;
                      const isValid = checkQuaterIsValid(rawValue);
                      const formattedValue = isValid ? autoFormateDate(formatQuater(rawValue)) : rawValue;
                      dispatch(setStubInvoiceFilterValue('startQtr', formattedValue));
                    }}
                  />
                  <NDCDetailsTextFieldComponent
                    label="End Quarter"
                    required
                    value={(searchFilter && searchFilter.endQtr) || ''}
                    error={
                      (errors && errors.endQtrReq
                        ? END_QUATER_REQ
                        : errors && errors.endQtr
                        ? QUARTER_FORMAT_ERROR
                        : errors && errors.endQtrReq1
                        ? END_QTR_ERROR
                        : null) || false
                    }
                    helperText={
                      (errors && errors.endQtrReq
                        ? END_QUATER_REQ
                        : errors && errors.endQtr
                        ? QUARTER_FORMAT_ERROR
                        : errors && errors.endQtrReq1
                        ? END_QTR_ERROR
                        : null) || false
                    }
                    className="ml-2 with-select"
                    disabled={false}
                    maxLength={6}
                    onChange={(e) => {
                      setSuccessMessages([]);
                      if (e.target.value === '') {
                        dispatch(setStubInvoiceFilterValue('endQtr', null));
                      } else if (
                        /^[0-9/Q]+$/g.test(e.target.value.toUpperCase())
                      ) {
                        dispatch(
                          setStubInvoiceFilterValue(
                            'endQtr',
                            e.target.value.toUpperCase()
                          )
                        );
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur('endQtr');
                      const rawValue = searchFilter?.endQtr;
                      const isValid = checkQuaterIsValid(rawValue);
                      const formattedValue = isValid ? autoFormateDate(formatQuater(rawValue)) : rawValue;
                      dispatch(setStubInvoiceFilterValue('endQtr', formattedValue));
                    }}

                  />
                </div>
              )}
              {searchFilter.createFor === createForRadioData[1].value && (
                <div className="m-0 col-6 d-flex">
                  <NDCDetailsTextFieldComponent
                    label="Manufacturer ID"
                    value={(searchFilter && searchFilter.mfg_id) || ''}
                    error={(errors && errors.mfg_id) || false}
                    className="ml-0 with-select"
                    disabled={false}
                    maxLength={10}
                    onChange={(e) => {
                      if (e.target.value === '') {
                        dispatch(setStubInvoiceFilterValue('mfg_id', null));
                      } else if (/^[0-9]+$/.test(e.target.value)) {
                        dispatch(
                          setStubInvoiceFilterValue('mfg_id', e.target.value)
                        );
                      }
                    }}
                    onBlur={() => handleBlur('mfg_id')}

                  />
                  <NDCDetailsTextFieldComponent
                    label="Quarter"
                    value={(searchFilter && searchFilter.qtr) || ''}
                    error={(errors && errors.qtr) || false}
                    className="ml-2 with-select"
                    disabled={false}
                    maxLength={6}
                    onChange={(e) => {
                      if (e.target.value === '') {
                        dispatch(setStubInvoiceFilterValue('qtr', null));
                      } else if (
                        /^[0-9/Q]+$/g.test(e.target.value.toUpperCase())
                      ) {
                        dispatch(
                          setStubInvoiceFilterValue(
                            'qtr',
                            e.target.value.toUpperCase()
                          )
                        );
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur('qtr')
                      let value = null;
                      if (
                        searchFilter &&
                        searchFilter.qtr &&
                        checkQuaterIsValid(searchFilter.qtr)
                      ) {
                        value = formatQuater(searchFilter.qtr);
                      } else {
                        value = searchFilter.qtr;
                      }
                      dispatch(setStubInvoiceFilterValue('qtr', value));
                    }}
                  />
                </div>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-12 my-3 d-flex align-items-center justify-content-end">
          <Button
            className="btn-success same-font-family d-flex align-items-center"
            onClick={() => {
              setSuccessMessages([]);
              setErrorMessages([]);
              if (validFilter(searchFilter)) {
                dispatch(
                  createStubInvoiceAPI(
                    {
                      createFor: searchFilter.createFor,
                      rebateProgramCode: searchFilter.rpc,
                      userId: logInUser || '',
                      mfgTypeCd:
                        searchFilter.planType === 'FD' ||
                        searchFilter.planType === 'ST'
                          ? 'G'
                          : 'C',
                      ...(searchFilter.createFor === createForRadioData[0].value
                        ? {
                            startQuarter: searchFilter.startQtr,
                            endQuarter: searchFilter.endQtr,
                          }
                        : {
                            quarter: searchFilter.qtr,
                            mfgId: searchFilter.mfg_id,
                            asMode: 1,
                          }),
                    },
                    (message) => {
                      setSuccessMessages([
                        SUCCESS_MESSAGE_STUB_INVOICE || message,
                      ]);
                    },
                    (message) => {
                      setErrorMessages([
                        message || FAILED_MESSAGE_STUB_INVOICE,
                      ]);
                    }
                  )
                );
              }
            }}
          >
            <SVGComponent iconName="Create-new-icon" />{' '}
            <span style={{ paddingLeft: '5px' }}>Create Stub Invoice</span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateStubInvoiceHeader;
